import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/app/not-found.tsx");
